import React, { useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';

const AppShell = ({ children }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleBurgerClick = () => {
    if (window.innerWidth >= 1024) {
      setCollapsed((prev) => !prev);
    } else {
      setMobileOpen(true);
    }
  };

  const handleCollapse = (value) => {
    setCollapsed(value);
  };

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar
        collapsed={collapsed}
        onCollapse={handleCollapse}
        mobileOpen={mobileOpen}
        onMobileOpenChange={setMobileOpen}
      />
      <div className="flex flex-col flex-1 min-w-0">
        <Navbar bugerClick={handleBurgerClick} />
        <main className="flex-1 pt-1 px-2 md:pt-4 md:px-4 overflow-auto">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default AppShell;
